export enum ServiceTileType {
  ADD = 'ADD',
  DELETE = 'DELETE',
  EDIT = 'EDIT',
}
